import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  padding: 0px 80px;
`

export const LabelRow = styled.div`
  display: grid;
  grid-template-columns: ${({ showComissions }) => 
    showComissions ? '4fr 5fr 5fr 4fr 3fr 3fr 3fr' : '4fr 5fr 5fr 4fr 3fr 3fr'
  };
  gap: 10px;
  justify-content: center;
  align-items: center;
  justify-items: center;
  margin: 0px 10px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 16px;
  text-align: center;
`

export const Title = styled(InfoText)`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 7px;
`
